import { Button, Icon } from "@qw/ui";

import { useChatSession } from "../providers/chat-session-provider";

export const ChatClose = () => {
  const { onClose } = useChatSession();

  if (!onClose) {
    return null;
  }

  return (
    <Button variant="ghost" size="xs" onClick={onClose} className="rounded-full text-sm">
      <Icon icon="close" />
    </Button>
  );
};
